// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tac__footer[data-v-487e77db]{margin-top:60px}", ""]);
// Exports
module.exports = exports;
